module.exports = __webpack_public_path__ + "static/img/dress_casual_mobile_pending.52df78b6.jpg";